module.exports = __webpack_public_path__ + "static/img/logo_b.158ae092.png";